import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import { BaseInput } from "../baseInput/BaseInput";
import { Icon } from "../icon/Icon";

import "./Switcher.scss";

export const Switcher = ({ checked, disabled, onChange, id, ...attrs }) => (
  <div
    data-testid={"switch"}
    className={classnames("switcher", {
      "switcher--checked": checked,
      "switcher--disabled": disabled,
    })}
  >
    <BaseInput
      id={id}
      type="checkbox"
      onChange={onChange}
      checked={checked}
      disabled={disabled}
      hidden
      {...attrs}
      role={"switch"}
      aria-checked={checked}
    />
    <label htmlFor={id} className="switch">
      <span className={"switch__toggle"}></span>
      <span className={"switch__status"}>
        <span className={"switch__status--on"}>
          <Icon icon={"fa-solid fa-check"} />
        </span>
        <span className={"switch__status--off"}>
          <Icon icon={"fa-solid fa-times"} />
        </span>
      </span>
    </label>
  </div>
);

Switcher.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
